<template>
  <div class="row">
    <div class="col d-flex align-items-center">
      <div>
        <p class="strong">{{ coordinator.name }}</p>
        <p class="small text-muted">
          {{ coordinator.email }} <span v-if="coordinator.phone">- {{ coordinator.phone }}</span>
        </p>
      </div>
    </div>
  </div><!-- /.row -->
</template>

<script>
export default {
  props: {
    coordinator: {
      required: true,
      type: Object
    }
  }
}
</script>
